<template>
  <section class="h_74">
    <div class="title_container">
      <img class="title" src="@/v2/mobile/assets/image/h_74_title.svg" alt="" />
      <div class="des f-center-sub-title">
        浏览器升级，支持创建 web 轻应用，快捷访问高频网站 <sup>[8]</sup>
      </div>
    </div>
    <div class="video_container" v-ia>
      <m-video
        src="@/v2/mobile/assets/video/v_74.mp4"
        poster="@/v2/mobile/assets/video/poster/v_74.webp"
        class="border_container_light"
        disablepictureinpicture
        muted
        x5-playsinline
        playsinline
        webkit-playsinline="true"
        autoplay
        ref="video1"
      ></m-video>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs.video1)"
      />
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleAreaH5(this.$refs.video1)
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.h_74 {
  position: relative;
  background-color: #ffffff;
  margin-top: -5px;
  z-index: 16;
  .title_container {
    padding: 120px 24px 0;
  }
  .title {
    width: 55%;
    height: 100%;
  }
  .des {
    margin: 20px 0;
    font-size: 16px;
    line-height: 1.6;
    color: #00000080;
    max-width: 100%;
    word-wrap: break-word;
  }
  .video_container {
    display: flex;
    flex-direction: column;
    margin: 0 24px;
    width: calc(100% - 48px);
    video {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    .alive_replay {
      margin-top: 20px;
      color: #3b82fc;
      align-self: flex-start;
    }
  }
}
</style>
